import React from 'react'

const Card = ({ children, className = '', ...props }) => {
  return (
    <div
      className={`bg-surface rounded-2xl shadow-card ${className}`}
      {...props}
    >
      {children}
    </div>
  )
}

export default Card
